import React from "react";

const Bulk = () => {
  return (
    <div className="text-center bg-purple-300 py-16 px-6 sm:px-12 md:px-24 font-sans">
      <h2
        className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-center font-bold mb-6 text-white"
         style={{ fontFamily: "'Times New Roman', Serif" }}
      >
        We take Customized Tailoring Order Too <br /> <span  className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center font-bold mb-6 text-white"
         style={{ fontFamily: "'Times New Roman', Serif" }}> Customize Your Favourite Outfit</span>
      </h2>
      <p className="text-base sm:text-lg max-w-4xl mx-auto leading-relaxed text-gray-800">
        From Aavryaa its so easy to get the dream customized outfit in perfect fit, get your dream customized dress from our customized fabrics.. U dream it , we customize it in perfect fit.
      </p>
      <p className="text-lg sm:text-xl font-normal mt-6 text-black">
        
        <b> BOOK A VIDEO CALL TO GET YOUR OUTFITS<br /> MADE TO YOUR EXACT MEASUREMENTS</b>
      </p>
      <a
        href="https://wa.me/9944592904"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="bg-white text-black font-bold py-3 px-6 text-lg rounded-md mt-8 hover:bg-purple-800 hover:text-white transition duration-300">
          Customize Now
        </button>
      </a>
    </div>
  );
};

export default Bulk;
